import { ON_BLOCK_SELECTED, ON_BLOCK_TARGETED } from '../state-constants/stateConstants';

export const onBlockSelected = (target) => ({
  type: ON_BLOCK_SELECTED,
  payload: target,
});

export const onBlockTargeted = (target) => ({
  type: ON_BLOCK_TARGETED,
  payload: target,
});


// WEBPACK FOOTER //
// ./src/state-actions/onBlockSelections.js